module.exports = __webpack_public_path__ + "static/media/Twitterwithround.b4009557.svg";